<template>
	<div v-if="isShowLogin" class="layout">
		<div class="page-login">
			<!-- 左侧 -->
			<div class="left-img fl">
				<div class="left-text">
					<img
						class="senguo-text-logo"
						src="~@/assets/images/senguo_text_logo.svg"
						alt=""
					/>
					<p class="login-title">{{ loginTitle }}</p>
				</div>
				<img
					class="logo-img"
					src="~@/assets/images/senguo_login_bg_img.png"
					alt
				/>
			</div>
			<!-- 右侧 -->
			<div class="right-list">
				<p class="label">
					{{ currentPanelTitle }}
				</p>

				<div class="half-hide-img">
					<div class="mask">
						<img
							v-if="loginWay == 'account-login'"
							@click="handleChangeLoginWay('scan-code-login')"
							src="~@/assets/images/code_login.png"
							alt=""
						/>
						<img
							v-if="loginWay == 'scan-code-login'"
							@click="handleChangeLoginWay('account-login')"
							src="~@/assets/images/account_login.png"
							alt=""
						/>
					</div>
				</div>

				<!-- tab -->
				<div
					class="login-type-tab login_type_tab"
					v-if="
						loginWay == 'scan-code-login' ||
						!isGlobalRegion ||
						accountView === 'login'
					"
				>
					<span
						@click="loginType = 'wx'"
						:class="{ active: loginType === 'wx' }"
						v-show="loginWay == 'scan-code-login'"
						class="item login-by-wx"
						>微信扫码</span
					>
					<span
						@click="loginType = 'app'"
						:class="{ active: loginType === 'app' }"
						v-show="loginWay == 'scan-code-login'"
						class="item login-by-app"
						>app扫码</span
					>
					<span
						@click="loginType = 'pwd'"
						:class="{ active: loginType === 'pwd' }"
						v-show="loginWay == 'account-login' && !isGlobalRegion"
						class="item login-by-phone"
						>账号密码</span
					>
					<span
						@click="loginType = 'phone'"
						:class="{ active: loginType === 'phone' }"
						v-show="loginWay == 'account-login' && !isGlobalRegion"
						class="item login-by-phone"
						>手机号</span
					>
					<span
						v-if="loginWay == 'account-login' && isGlobalRegion"
						@click="switchAccountView('login')"
						:class="{ active: accountView === 'login' }"
						class="item login-by-phone"
						>邮箱密码登录</span
					>
				</div>

				<!-- 扫码登录 -->
				<div class="scan-code-login" v-if="loginWay == 'scan-code-login'">
					<!-- app扫码登录 -->
					<div v-if="loginType === 'app'" class="wrap-app-login ltab_box">
						<div class="login-qrcode-box">
							<div
								:class="[
									'wrap-login-qrcode',
									isHover ? 'wrap-app-scan-qrcode' : '',
								]"
								title
								v-loading="loading"
								element-loading-spinner="el-icon-loading"
								id="code1"
							>
								<img
									v-show="false"
									ref="logo-add-app-scan-icon"
									src="~@/assets/images/app_scan_icon.png"
									alt=""
								/>
								<canvas class="app-scan-qrcode" ref="app-scan-canvas"></canvas>
								<img
									class="app-scan-remind"
									src="~@/assets/images/app_tip.png"
									alt=""
								/>
							</div>
							<div
								:class="[
									'wrap-qrcode-outtime',
									isHover ? 'qrcode-process-remind-translate' : '',
								]"
								v-if="isQrCodeExpired"
							>
								<div style="margin-top: 50px">二维码已失效</div>
								<a
									@click="getAppScanQrImage"
									class="btn-refresh-qrcode btn_refresh_qrcode"
									href="javascript:;"
									>刷新</a
								>
							</div>
							<div
								:class="[
									'qrcode-process-remind',
									isHover ? 'qrcode-process-remind-translate' : '',
								]"
								v-if="process.hasScaned"
							>
								<p>二维码已扫描</p>
								<p style="margin-top: 10px">请在手机上确认登录</p>
								<p class="back-to-qrcode" @click="backToQrcode">返回二维码</p>
							</div>
							<div
								:class="[
									'qrcode-process-remind',
									isHover ? 'qrcode-process-remind-translate' : '',
								]"
								v-if="process.hasCanceled"
							>
								<p>登录已取消</p>
								<p style="margin-top: 10px">正在刷新二维码</p>
							</div>
						</div>
						<div class="app-login-info">
							使用
							<el-popover placement="top" trigger="hover">
								<img
									class="app-download-link"
									src="~@/assets/images/pfeasy_app_download.png"
									alt=""
								/>
								<img
									class="app-logo"
									slot="reference"
									src="~@/assets/images/logo_easy.png"
									alt=""
								/>
							</el-popover>
							批发易、
							<el-popover placement="top" trigger="hover">
								<img
									class="app-download-link"
									src="~@/assets/images/ls_app_download.png"
									alt=""
								/>
								<img
									class="app-logo"
									slot="reference"
									src="~@/assets/images/logo_ls.png"
									alt=""
								/>
							</el-popover>
							零售通顶部扫一扫即可登录
						</div>
					</div>
					<!-- 微信登录 -->
					<div v-show="loginType === 'wx'" class="wrap-wx-login ltab_box">
						<div class="login-qrcode-box">
							<div
								class="wrap-login-qrcode"
								title
								id="code2"
								v-loading="loading"
								element-loading-spinner="el-icon-loading"
							>
								<img
									v-show="false"
									ref="logo-add-wx-scan-icon"
									src="~@/assets/images/wx_scan_icon.png"
									alt=""
								/>
								<canvas ref="canvas" v-loading="loading"></canvas>
							</div>
							<div class="wrap-qrcode-outtime" v-if="isQrCodeExpired">
								<div style="margin-top: 50px">二维码已失效</div>
								<a
									@click="getWxQrImage"
									class="btn-refresh-qrcode btn_refresh_qrcode"
									href="javascript:;"
									>刷新</a
								>
							</div>
						</div>
						<div class="wx-login-info">使用微信扫码关注公众号即可登录</div>
					</div>
				</div>

				<!-- 账号密码登录 -->
				<div class="account-login" v-if="loginWay == 'account-login'">
					<template v-if="!isGlobalRegion">
						<!-- 账号密码 -->
						<div v-show="loginType === 'pwd'" class="wrap-usernum-login ltab_box">
							<div class="username login-input">
								<el-input
									type="tel"
									v-model="accountId"
									placeholder="手机号"
									:maxlength="11"
									@input="phoneNumberLimit($data, 'accountId')"
								/>
							</div>
							<div class="pwd login-input wrap_pw">
								<el-input
									type="password"
									v-model="password"
									placeholder="输入密码"
									:maxlength="16"
									@input="passwordLimit($data, 'password')"
									@keyup.enter.native="loginByPwd"
								/>
							</div>
							<div class="login-btn">
								<button @click="loginByPwd" type="button" id="pwdLogin">
									登录
								</button>
							</div>
						</div>
						<!-- 手机号 -->
						<div
							v-show="loginType === 'phone'"
							class="wrap-usernum-login ltab_box"
						>
							<div
								class="username login-input"
								:class="{ 'ipt-error': errorMsgForm.isPhoneError }"
							>
								<el-input
									type="tel"
									v-model="phoneNumber"
									placeholder="手机号"
									:maxlength="11"
									@input="phoneNumberLimit($data, 'phoneNumber')"
									@focus="errorMsgForm.isPhoneError = false"
								/>
							</div>
							<p class="error-msg" v-if="errorMsgForm.isPhoneError">
								手机号不正确
							</p>
							<div
								class="pwd login-input wrap_pw"
								:class="{ 'ipt-error': errorMsgForm.isCodeError }"
							>
								<el-input
									type="tel"
									v-model="code"
									placeholder="输入短信验证码"
									:maxlength="4"
									@input="verifyCodeLimit($data, 'code')"
									@focus="errorMsgForm.isCodeError = false"
									@keyup.enter.native="loginByPhone"
								/>
								<span
									ref="getCode"
									@click="getLoginMessage"
									class="get-code"
									:class="{ get_code: lock }"
									data-action="login"
									>{{ phoneMsg }}</span
								>
							</div>
							<p class="error-msg" v-if="errorMsgForm.isCodeError">
								验证码不正确
							</p>
							<div class="login-btn">
								<button @click="loginByPhone" type="button" id="phoneLogin">
									登录
								</button>
							</div>
						</div>
					</template>

					<template v-else>
						<div class="wrap-usernum-login ltab_box">
							<div
								v-if="accountView !== 'login'"
								class="account-view-header"
							>
								<span>{{
									accountView === "register" ? "使用邮箱完成开户注册" : "通过邮箱重置登录密码"
								}}</span>
								<a href="javascript:;" @click="switchAccountView('login')"
									>返回登录</a
								>
							</div>

							<div v-if="accountView === 'login'">
								<div
									class="username login-input"
									:class="{ 'ipt-error': !!emailErrors.login.email }"
								>
									<el-input
										type="text"
										v-model="emailForms.login.email"
										placeholder="输入邮箱"
										:maxlength="60"
										@focus="emailErrors.login.email = ''"
									/>
								</div>
								<p class="error-msg" v-if="emailErrors.login.email">
									{{ emailErrors.login.email }}
								</p>
								<div
									class="pwd login-input wrap_pw"
									:class="{ 'ipt-error': !!emailErrors.login.password }"
								>
									<el-input
										type="password"
										v-model="emailForms.login.password"
										placeholder="输入密码"
										:maxlength="16"
										@input="passwordLimit(emailForms.login, 'password')"
										@focus="emailErrors.login.password = ''"
										@keyup.enter.native="loginByEmail"
									/>
								</div>
								<p class="error-msg" v-if="emailErrors.login.password">
									{{ emailErrors.login.password }}
								</p>
									<div class="login-btn">
										<button @click="loginByEmail" type="button">
											登录
										</button>
									</div>
								</div>

							<div v-else-if="accountView === 'register'">
								<div
									class="username login-input"
									:class="{ 'ipt-error': !!emailErrors.register.email }"
								>
									<el-input
										type="text"
										v-model="emailForms.register.email"
										placeholder="输入邮箱"
										:maxlength="60"
										@focus="emailErrors.register.email = ''"
									/>
								</div>
								<p class="error-msg" v-if="emailErrors.register.email">
									{{ emailErrors.register.email }}
								</p>
								<div
									class="pwd login-input wrap_pw"
									:class="{ 'ipt-error': !!emailErrors.register.code }"
								>
									<el-input
										type="tel"
										v-model="emailForms.register.code"
										placeholder="输入邮箱验证码"
										:maxlength="6"
										@input="limitEmailCode('register')"
										@focus="emailErrors.register.code = ''"
										@keyup.enter.native="registerByEmail"
									/>
									<span
										@click="sendEmailCodeByView('register')"
										class="get-code"
										:class="{ get_code: emailCodeLock }"
										>{{ emailCodeText }}</span
									>
								</div>
								<p class="error-msg" v-if="emailErrors.register.code">
									{{ emailErrors.register.code }}
								</p>
								<div
									class="pwd login-input wrap_pw"
									:class="{ 'ipt-error': !!emailErrors.register.password }"
								>
									<el-input
										type="password"
										v-model="emailForms.register.password"
										placeholder="设置密码"
										:maxlength="16"
										@input="passwordLimit(emailForms.register, 'password')"
										@focus="emailErrors.register.password = ''"
										@keyup.enter.native="registerByEmail"
									/>
								</div>
								<p class="error-msg" v-if="emailErrors.register.password">
									{{ emailErrors.register.password }}
								</p>
								<div class="login-btn">
									<button @click="registerByEmail" type="button">
										注册并登录
									</button>
								</div>
								<div class="account-extra-links single">
									<a href="javascript:;" @click="switchAccountView('login')"
										>已有账号？去登录</a
									>
								</div>
							</div>

							<div v-else>
								<div
									class="username login-input"
									:class="{ 'ipt-error': !!emailErrors.reset.email }"
								>
									<el-input
										type="text"
										v-model="emailForms.reset.email"
										placeholder="输入邮箱"
										:maxlength="60"
										@focus="emailErrors.reset.email = ''"
									/>
								</div>
								<p class="error-msg" v-if="emailErrors.reset.email">
									{{ emailErrors.reset.email }}
								</p>
								<div
									class="pwd login-input wrap_pw"
									:class="{ 'ipt-error': !!emailErrors.reset.code }"
								>
									<el-input
										type="tel"
										v-model="emailForms.reset.code"
										placeholder="输入邮箱验证码"
										:maxlength="6"
										@input="limitEmailCode('reset')"
										@focus="emailErrors.reset.code = ''"
										@keyup.enter.native="resetPasswordByEmail"
									/>
									<span
										@click="sendEmailCodeByView('reset')"
										class="get-code"
										:class="{ get_code: emailCodeLock }"
										>{{ emailCodeText }}</span
									>
								</div>
								<p class="error-msg" v-if="emailErrors.reset.code">
									{{ emailErrors.reset.code }}
								</p>
								<div
									class="pwd login-input wrap_pw"
									:class="{ 'ipt-error': !!emailErrors.reset.password }"
								>
									<el-input
										type="password"
										v-model="emailForms.reset.password"
										placeholder="设置新密码"
										:maxlength="16"
										@input="passwordLimit(emailForms.reset, 'password')"
										@focus="emailErrors.reset.password = ''"
										@keyup.enter.native="resetPasswordByEmail"
									/>
								</div>
								<p class="error-msg" v-if="emailErrors.reset.password">
									{{ emailErrors.reset.password }}
								</p>
								<div class="login-btn">
									<button @click="resetPasswordByEmail" type="button">
										确认重置
									</button>
								</div>
								<div class="account-extra-links single">
									<a href="javascript:;" @click="switchAccountView('login')"
										>返回登录</a
									>
								</div>
							</div>
						</div>
					</template>
				</div>

				<div class="login-privacy">
					“登录”即表示同意
					<a
						class="login-link"
						href="https://i.senguo.cc/bbs/privacy/792812a51880032b"
						target="_blank"
						>《用户协议》</a
					>和
					<a
						class="login-link"
						href="https://i.senguo.cc/bbs/privacy/5eb92b2b36fcc540"
						target="_blank"
						>《隐私协议》</a
					>
				</div>
			</div>
		</div>

		<ypsdk ref="ypsdk" />

		<tips-dialog ref="passwordTipsDialog" title="系统提示" btnContent="确认">
			<div slot="content">
				<p>您的密码过于简单，请更换其他方式登录</p>
				<p>并在登录后前往个人中心修改密码</p>
			</div>
		</tips-dialog>
	</div>
</template>

<script>
import tipsDialog from "./components/tips-dialog.vue";
import BTime from "best-calendar";
import qrcode from "qrcode";
import ypsdk from "@/components/ypsdk/ypsdk";
import encryption from "@/assets/js/encryption.js";
import { inputLimit, isPasswordEffective } from "@/utils";
import api from "@/api";
import { isCashierEnv } from "@/utils";
import { CN_SPECIAL, GLOBAL_FLEX, shouldForceBindPhone, shouldForceBindWx, getAuthStrategy } from "@/utils/auth-strategy";
const fetch = api.fetch;
const bindWxUrl = "/sellerRegister";
const bindPhoneUrl = "/sellerRegister?type=bind_phone";
const CN_TIMEZONES = new Set(["Asia/Shanghai", "Asia/Urumqi"]);
const LOGIN_REGION_LOG_PREFIX = "[login-region]";

function normalizeLocaleTag(locale = "") {
	return String(locale || "").trim().toLowerCase().replace(/_/g, "-");
}

function normalizeRegionCode(regionCode = "") {
	return String(regionCode || "").trim().toUpperCase();
}

function normalizeTimezone(timezone = "") {
	return String(timezone || "").trim();
}

function getSystemLocaleTag() {
	if (typeof navigator === "undefined") return "";
	return normalizeLocaleTag(
		(navigator.languages && navigator.languages[0]) || navigator.language
	);
}

function getRegionCodeFromLocale(locale = "") {
	const segments = normalizeLocaleTag(locale).split("-").filter(Boolean);
	for (let i = segments.length - 1; i >= 0; i -= 1) {
		if (/^[a-z]{2}$/i.test(segments[i])) {
			return normalizeRegionCode(segments[i]);
		}
	}
	return "";
}

function getSystemRegionCode() {
	return getRegionCodeFromLocale(getSystemLocaleTag());
}

function getSystemTimezone() {
	try {
		return Intl.DateTimeFormat().resolvedOptions().timeZone || "";
	} catch (e) {
		return "";
	}
}

function guessAuthStrategyByRegion() {
	const regionCode = getSystemRegionCode();
	const locale = getSystemLocaleTag();
	const timezone = getSystemTimezone();
	if (regionCode) {
		return regionCode === "CN" ? CN_SPECIAL : GLOBAL_FLEX;
	}
	const isCnLocale = !locale || locale === "zh-cn" || locale === "zh";
	const isCnTimezone = !timezone || CN_TIMEZONES.has(timezone);
	return isCnLocale && isCnTimezone ? CN_SPECIAL : GLOBAL_FLEX;
}

function shouldRequestAuthBootstrap() {
	const regionCode = getSystemRegionCode();
	const locale = getSystemLocaleTag();
	const timezone = getSystemTimezone();
	if (regionCode) {
		return regionCode !== "CN";
	}
	const isCnLocale = !locale || locale === "zh-cn" || locale === "zh";
	const isCnTimezone = !timezone || CN_TIMEZONES.has(timezone);
	return !(isCnLocale && isCnTimezone);
}

function buildAuthBootstrapPayload() {
	return {
		native_region_code: getSystemRegionCode(),
		native_language: getSystemLocaleTag(),
		browser_language: getSystemLocaleTag(),
		timezone: normalizeTimezone(getSystemTimezone()),
		platform: "web",
	};
}

export default {
	data() {
	return {
			loginTitle: isCashierEnv() ? "收银台登录页面" : "商户后台登录页面",
			loginWay: "scan-code-login", // 扫码登录还是账号登录
			loginType: "wx", // 具体哪种登录方式
			authStrategyPreview: guessAuthStrategyByRegion(),
			accountView: "login",
			oa: "oa_pifa",
			scan_id: "", // app扫码登录时的scan_id
			accountId: "",
			password: "",
			phoneNumber: "",
			code: "",
			emailForms: {
				login: {
					email: "",
					password: "",
				},
				register: {
					email: "",
					code: "",
					password: "",
				},
				reset: {
					email: "",
					code: "",
					password: "",
				},
			},
			emailErrors: {
				login: {
					email: "",
					password: "",
				},
				register: {
					email: "",
					code: "",
					password: "",
				},
				reset: {
					email: "",
					code: "",
					password: "",
				},
			},
			emailCodeText: "获取验证码",
			emailCodeLock: false,
			hasResolvedAuthBootstrap: false,
			isResolvingAuthBootstrap: false,
			phoneMsg: "获取验证码",
			lock: false,
			emailLoginLock: false,
			emailRegisterLock: false,
			emailResetLock: false,
			waitTimer: null, // 计时timer
			pollingTimer: null, // 轮询timer
			emailCountDown: null,
			isQrCodeExpired: false, // 二维码是否超时
			process: {
				// 二维码过程状态
				hasScaned: false, // 已被扫
				hasCanceled: false, // 已取消
			},
			errorMsgForm: {
				isPhoneError: false,
				isCodeError: false,
			},
			isShowLogin: true,
			isHover: false,
			loading: false,
		};
	},
	computed: {
		isGlobalRegion() {
			return this.authStrategyPreview === GLOBAL_FLEX;
		},
		currentPanelTitle() {
			if (this.loginType === "app" || this.loginType === "wx") {
				return "扫码登录";
			}
			if (this.isGlobalRegion) {
				return "邮箱登录";
			}
			return "账号登录";
		},
	},
	watch: {
		loginType(newType) {
			this.clearTimer();
			if (newType === "wx") {
				this.getWxQrImage();
			} else if (newType === "app") {
				this.getAppScanQrImage();
			}
		},
	},
	created() {
		this.phoneReg = /^1[3456789]\d{9}$/;
		this.emailReg =
			/^[a-z0-9]+([._\\-]*[a-z0-9])*@([a-z0-9]+[-a-z0-9]*[a-z0-9]+.){1,63}[a-z0-9]+$/;
		this.firstPicValid = true;
		if (this.isGlobalRegion) {
			this.loginWay = "account-login";
			this.loginType = "pwd";
		}
		console.info(LOGIN_REGION_LOG_PREFIX, "created", {
			previewStrategy: this.authStrategyPreview,
			locale: getSystemLocaleTag(),
			timezone: getSystemTimezone(),
			shouldRequestAuthBootstrap: shouldRequestAuthBootstrap(),
		});
	},
	mounted() {
		this.resolveAuthBootstrap();
		this.initPage();
	},
	beforeDestroy() {
		this.clearTimer();
		this.stopEmailCodeCountDown();
	},
	beforeRouteEnter(to, from, next) {
		fetch
			.get({
				url: "/user",
			})
			.then((data) => {
				if (data.success && data.user) {
					if (shouldForceBindPhone(data.user)) {
						next((vm) => {
							vm.$message.error("请先绑定手机号");
							vm.$router.push(bindPhoneUrl);
						});
					} else if (shouldForceBindWx(data.user)) {
						next((vm) => {
							vm.$message.error("请先绑定微信");
							// 绑定微信 (携带参数)
							if (vm.$route.query.oa === "new_ls") {
								vm.$router.push({
									path: bindWxUrl,
									query: {
										oa: "new_ls",
									},
								});
							} else {
								vm.$router.push(bindWxUrl);
							}
						});
					} else {
						next((vm) => {
							vm.isShowLogin = false;
							vm.goToUrl();
						});
					}
				} else {
					next();
				}
			})
			.catch(() => next());
	},
	methods: {
		phoneNumberLimit: inputLimit(/^([1]{1}\d{0,10})$/),
		passwordLimit: inputLimit(/^\w*$/),
		verifyCodeLimit: inputLimit(/^\d{0,4}$/),

		getLocale() {
			if (typeof navigator === "undefined") return "zh-CN";
			return (
				navigator.language ||
				(navigator.languages && navigator.languages[0]) ||
				"zh-CN"
			);
		},

		async resolveAuthBootstrap() {
			if (this.hasResolvedAuthBootstrap || this.isResolvingAuthBootstrap) {
				console.info(LOGIN_REGION_LOG_PREFIX, "skip duplicated auth bootstrap");
				return;
			}

			if (!shouldRequestAuthBootstrap()) {
				this.hasResolvedAuthBootstrap = true;
				console.info(LOGIN_REGION_LOG_PREFIX, "skip auth bootstrap by local hint", {
					locale: getSystemLocaleTag(),
					timezone: getSystemTimezone(),
				});
				return;
			}

			this.isResolvingAuthBootstrap = true;
			const payload = buildAuthBootstrapPayload();
			console.info(LOGIN_REGION_LOG_PREFIX, "request auth bootstrap", payload);

			try {
					const res = await this.$fetch.post({
						url: "/auth/bootstrap",
						params: payload,
					});
				const shouldEnableEmailLogin =
					Number(res.suggested_auth_strategy) === GLOBAL_FLEX &&
					Boolean(res.allow_email_login);
				this.authStrategyPreview = shouldEnableEmailLogin
					? GLOBAL_FLEX
					: CN_SPECIAL;
				if (shouldEnableEmailLogin) {
					this.loginWay = "account-login";
					this.loginType = "pwd";
					this.switchAccountView("login");
				} else {
					this.loginWay = "scan-code-login";
					this.loginType = "wx";
					this.getWxQrImage();
				}
				console.info(LOGIN_REGION_LOG_PREFIX, "auth bootstrap success", {
					response: res,
					resolvedStrategy: this.authStrategyPreview,
				});
			} catch (e) {
				this.authStrategyPreview = CN_SPECIAL;
				this.loginWay = "scan-code-login";
				this.loginType = "wx";
				this.getWxQrImage();
				console.warn(LOGIN_REGION_LOG_PREFIX, "auth bootstrap failed, fallback cn", e);
			} finally {
				this.hasResolvedAuthBootstrap = true;
				this.isResolvingAuthBootstrap = false;
			}
		},

		clearEmailErrors(view) {
			if (view) {
				this.emailErrors[view] = {
					email: "",
					code: "",
					password: "",
				};
				return;
			}
			this.emailErrors = {
				login: {
					email: "",
					password: "",
				},
				register: {
					email: "",
					code: "",
					password: "",
				},
				reset: {
					email: "",
					code: "",
					password: "",
				},
			};
		},

		getPrimaryEmail() {
			return (
				(this.emailForms.login.email || this.emailForms.register.email || this.emailForms.reset.email || "")
					.trim()
			);
		},

		switchAccountView(view) {
			const email = this.getPrimaryEmail();
			this.accountView = view;
			this.clearEmailErrors();
			if (view === "login") {
				this.emailForms.login.email = email || this.emailForms.login.email;
				this.emailForms.login.password = "";
				return;
			}
			this.emailForms[view].email = email || this.emailForms[view].email;
			this.emailForms[view].code = "";
			this.emailForms[view].password = "";
		},

		stopEmailCodeCountDown() {
			this.emailCountDown && this.emailCountDown.stop(true);
			this.emailCountDown = null;
			this.emailCodeLock = false;
			this.emailCodeText = "获取验证码";
		},

		startEmailCodeCountDown() {
			this.emailCodeLock = true;
			this.emailCountDown = new BTime.CountDown(60000, 0);
			this.emailCountDown.on("timing", (time) => {
				this.emailCodeText = `${time.second}s`;
			});
			this.emailCountDown.on("timend", () => {
				this.emailCodeLock = false;
				this.emailCodeText = "获取验证码";
			});
		},

		limitEmailCode(view) {
			this.emailForms[view].code = (this.emailForms[view].code || "")
				.replace(/[^\d]/g, "")
				.slice(0, 6);
		},

		validateEmail(email) {
			return this.emailReg.test((email || "").trim());
		},

		validPassword(str) {
			const numReg = /^[0-9]{8,16}$/;
			const strReg = /^[a-zA-Z]{8,16}$/;
			const pwdReg = /^[a-zA-Z0-9]{8,16}$/;
			return !numReg.test(str) && !strReg.test(str) && pwdReg.test(str);
		},

		validateEmailLoginForm() {
			const form = this.emailForms.login;
			this.clearEmailErrors("login");
			if (!form.email.trim()) {
				this.emailErrors.login.email = "请输入邮箱";
				return false;
			}
			if (!this.validateEmail(form.email)) {
				this.emailErrors.login.email = "请输入正确的邮箱";
				return false;
			}
			if (!form.password) {
				this.emailErrors.login.password = "请输入密码";
				return false;
			}
			if (!isPasswordEffective(form.password)) {
				this.$refs["passwordTipsDialog"].open();
				return false;
			}
			return true;
		},

		validateEmailActionForm(view) {
			const form = this.emailForms[view];
			this.clearEmailErrors(view);
			if (!form.email.trim()) {
				this.emailErrors[view].email = "请输入邮箱";
				return false;
			}
			if (!this.validateEmail(form.email)) {
				this.emailErrors[view].email = "请输入正确的邮箱";
				return false;
			}
			if (!form.code) {
				this.emailErrors[view].code = "请输入验证码";
				return false;
			}
			if (form.code.length !== 6) {
				this.emailErrors[view].code = "请输入6位验证码";
				return false;
			}
			if (!form.password) {
				this.emailErrors[view].password = "请输入密码";
				return false;
			}
			if (!this.validPassword(form.password)) {
				this.emailErrors[view].password = "请输入8-16位数字、字母组合的密码";
				return false;
			}
			return true;
		},

		/**
		 * 页面初始化
		 * 公众号迁移对应的登录、通知、支付、扫码公众号调整   https://tower.im/teams/175903/todos/50200/
		 * 微信登录：处理 公众号 oa_pifa-批发易(默认) oa_lingshou-零售通
		 */
		initPage() {
			if (this.$route.query.oa === "new_ls") {
				this.oa = "oa_lingshou";
			} else {
				this.oa = "oa_pifa";
			}
			if (!this.isGlobalRegion) {
				// wx扫码登录
				this.getWxQrImage();
			}
		},

		// 切换支付方式
		handleChangeLoginWay(type) {
			this.loading = false;
			this.loginWay = type;
			if (type === "scan-code-login") {
				this.loginType = "wx";
			} else {
				this.loginType = "pwd";
				if (this.isGlobalRegion) {
					this.switchAccountView("login");
				}
			}
		},

		sendEmailCodeByView(view) {
			const form = this.emailForms[view];
			if (!this.validateEmail(form.email)) {
				this.emailErrors[view].email = form.email
					? "请输入正确的邮箱"
					: "请输入邮箱";
				return;
			}
			if (this.emailCodeLock) return;
			this.startEmailCodeCountDown();
			this.$fetch
					.post({
						url: "/email-code/send",
						params: {
							action: view === "register" ? "register_email" : "reset_password",
							email: form.email.trim(),
							locale: this.getLocale(),
							auth_strategy: this.authStrategyPreview,
						},
					})
				.catch((e) => {
					this.openMessage(0, e.error_text || "获取验证码失败");
					this.stopEmailCodeCountDown();
				});
		},

		requestEmailPasswordLogin(email, password) {
			return this.$fetch.post({
				url: "/login?method=login_by_email_password",
				params: {
					email,
					password: encryption(password),
				},
			});
		},

		loginByEmail() {
			if (this.emailLoginLock) return;
			if (!this.validateEmailLoginForm()) return;
			this.emailLoginLock = true;
			const { email, password } = this.emailForms.login;
			this.requestEmailPasswordLogin(email.trim(), password)
				.then((data) => {
					if (data.success) {
						this.openMessage(1, "登录成功");
						this.goToUrl();
					} else {
						this.openMessage(0, "用户名或密码错误");
					}
				})
				.catch((e) => {
					if (
						e && e.error_text && (
							e.error_text.includes("密码错误") ||
							e.error_text.includes("邮箱")
						)
					) {
						this.openMessage(0, "用户名或密码错误");
					} else {
						this.openMessage(0, (e && e.error_text) || "登录失败");
					}
				})
				.finally(() => {
					this.emailLoginLock = false;
				});
		},

		registerByEmail() {
			if (this.emailRegisterLock) return;
			if (!this.validateEmailActionForm("register")) return;
			this.emailRegisterLock = true;
			const { email, code, password } = this.emailForms.register;
			this.$fetch
					.post({
						url: "/register/email",
						params: {
							email: email.trim(),
							code,
							password: encryption(password),
							locale: this.getLocale(),
							auth_strategy: this.authStrategyPreview,
						},
					})
				.then(() => {
					this.emailForms.login.email = email.trim();
					this.emailForms.login.password = password;
					return this.requestEmailPasswordLogin(email.trim(), password);
				})
				.then(() => {
					this.openMessage(1, "注册成功");
					this.goToUrl();
				})
				.catch((e) => {
					if (e.error_text && e.error_text.includes("验证码")) {
						this.emailErrors.register.code = e.error_text;
						return;
					}
					this.openMessage(0, e.error_text || "注册失败");
				})
				.finally(() => {
					this.emailRegisterLock = false;
				});
		},

		resetPasswordByEmail() {
			if (this.emailResetLock) return;
			if (!this.validateEmailActionForm("reset")) return;
			this.emailResetLock = true;
			const { email, code, password } = this.emailForms.reset;
			this.$fetch
				.post({
					url: "/password/reset-by-email",
					params: {
						email: email.trim(),
						code,
						password: encryption(password),
						locale: this.getLocale(),
					},
				})
				.then(() => {
					this.emailForms.login.email = email.trim();
					this.emailForms.login.password = "";
					this.switchAccountView("login");
					this.openMessage(1, "重置成功，请使用新密码登录");
				})
				.catch((e) => {
					if (e.error_text && e.error_text.includes("验证码")) {
						this.emailErrors.reset.code = e.error_text;
						return;
					}
					this.openMessage(0, e.error_text || "重置失败");
				})
				.finally(() => {
					this.emailResetLock = false;
				});
		},

		backToQrcode() {
			this.clearTimer();
			this.getAppScanQrImage();
		},

		// 二维码过期计时
		startTimer() {
			this.isQrCodeExpired = false;
			this.process = {
				hasScaned: false,
				hasCanceled: false,
			};
			this.waitTimer = setTimeout(() => {
				this.isQrCodeExpired = true;
				this.process = {
					hasScaned: false,
					hasCanceled: false,
				};
				this.pollingTimer && clearTimeout(this.pollingTimer);
			}, 1000 * 60 * 10);
		},

		// 清除计时
		clearTimer() {
			this.pollingTimer && clearTimeout(this.pollingTimer);
			this.waitTimer && clearTimeout(this.waitTimer);
		},

		// 微信登录：获取二维码
		getWxQrImage() {
			this.loading = true;
			this.$fetch
				.post({
					url: "/login?method=get_wx_ticket",
					params: {
						action: "login",
						oa: this.oa,
					},
				})
				.then((res) => {
					this.scene_id = res.scene_id;
					const canvas = this.$refs.canvas;
					this.loading = false;
					if (canvas) {
						qrcode.toCanvas(canvas, res.ticket_url, (e) => {
							if (e) {
								this.isQrCodeExpired = true;
								this.openMessage(0, "生成二维码失败");
							} else {
								const iconRef = this.$refs["logo-add-wx-scan-icon"];
								canvas.getContext("2d").drawImage(iconRef, 64, 64, 36, 36);
								this.startTimer();
								this.getWxLoginResult();
							}
						});
					}
				})
				.catch((e) => {
					this.loading = false;
					console.log(e);
					this.isQrCodeExpired = true;
					this.openMessage(0, e.error_text || "获取微信扫码登录二维码失败");
				});
		},

		// 微信登录：轮询结果
		getWxLoginResult() {
			this.$fetch
				.post({
					url: "/login?method=login_by_wx_ticket",
					params: {
						scene_id: this.scene_id,
						oa: this.oa,
					},
				})
				.then((res) => {
					if (!res.done && !this.isQrCodeExpired) {
						this.pollingTimer = setTimeout(() => {
							this.getWxLoginResult();
						}, 2000);
					} else {
						if (res.phone_bind) {
							// 绑定了手机
							this.openMessage(1, "登录成功");
							this.goToUrl();
						} else {
							// 未绑定手机
							this.$router.push({
								path: "/sellerRegister",
								query: {
									type: "bind_phone",
								},
							});
						}
					}
				})
				.catch((e) => {
					// 继续轮询
					// this.getWxLoginResult()
					this.openMessage(0, e.error_text || "检测微信绑定错误");
				});
		},

		// app扫码登录：获取二维码
		getAppScanQrImage() {
			this.isHover = false;
			this.loading = true;
			this.$fetch
				.get({
					url: "/login-qrcode/get",
					params: {
						platform: 2, // 代表中台发起的
					},
				})
				.then((data) => {
					this.isQrCodeExpired = false;
					this.scan_id = data.scan_id;
					const canvas = this.$refs["app-scan-canvas"];
					this.loading = false;
					if (canvas) {
						qrcode.toCanvas(canvas, data.link, (e) => {
							if (e) {
								this.isQrCodeExpired = true;
								this.openMessage(0, "生成二维码失败");
							} else {
								const iconRef = this.$refs["logo-add-app-scan-icon"];
								canvas.getContext("2d").drawImage(iconRef, 80, 80, 36, 36);
								this.startTimer();
								this.getAppScanLoginResult();
								this.isHover = true;
							}
						});
					}
				})
				.catch((e) => {
					this.loading = false;
					this.isQrCodeExpired = true;
					this.openMessage(0, e.error_text || "获取二维码失败");
				});
		},

		// app扫码登录：轮询结果
		getAppScanLoginResult() {
			this.$fetch
				.get({
					url: "/login-qrcode-status/get",
					params: {
						scan_id: this.scan_id,
					},
				})
				.then((res) => {
					if (res.status == 3) {
						// 登录成功：跳转页面
						this.openMessage(1, "登录成功");
						this.goToUrl();
					} else if (res.status == 1) {
						// 等待中：继续轮询
						this.pollingTimer = setTimeout(() => {
							this.getAppScanLoginResult();
						}, 2000);
					} else if (res.status == 4) {
						// 二维码已被扫：继续轮询
						this.process.hasCanceled = false;
						this.process.hasScaned = true;
						this.pollingTimer = setTimeout(() => {
							this.getAppScanLoginResult();
						}, 2000);
					} else if (res.status == 5) {
						// 已取消登录：重新生成二维码
						this.process.hasScaned = false;
						this.process.hasCanceled = true;
						setTimeout(() => {
							this.clearTimer();
							this.getAppScanQrImage();
						}, 1000);
					} else {
						// 无效
						this.openMessage(0, "二维码失效");
					}
				})
				.catch((e) => {
					this.openMessage(0, e.error_text || "app扫码登录轮询失败");
				});
		},

		getLoginMessage() {
			if (!this.phoneReg.test(this.phoneNumber)) {
				return (this.errorMsgForm.isPhoneError = true);
			}
			this.validCode();
		},

		validCode(captchaVerifyParam) {
			if (this.lock) return;
			this.lock = true;
			const params = {
				action: "login",
				phone: this.phoneNumber,
			};
			if (captchaVerifyParam) {
				// 图片验证
				params.captcha_verify_param = captchaVerifyParam;
			}
			this.countDown = new BTime.CountDown(60000, 0);
			this.countDown.on("timing", (time) => {
				this.phoneMsg = `${time.second}s`;
			});
			this.countDown.on("timend", () => {
				this.lock = false;
				this.phoneMsg = "获取验证码";
			});
			return this.$fetch
				.post({
					url: "/captcha",
					params,
				})
				.then(
					(data) => {
						if (data.need_captcha && this.firstPicValid) {
							// 图形验证
							this.firstPicValid = false;
							this.ypValid();
						} else {
							// 直接获取验证码
							this.firstPicValid = true;
						}
						return data;
					},
					(e) => {
						if (
							!e.success &&
							e.error_text.includes("图形验证") &&
							this.firstPicValid
						) {
							this.firstPicValid = false;
							return this.ypValid();
						}
						this.firstPicValid = true;
						this.openMessage(0, e.error_text || "获取验证码失败");
						this.countDown && this.countDown.stop(true);
						if (captchaVerifyParam) return Promise.reject(e);
					}
				);
		},

		ypValid() {
			this.countDown && this.countDown.stop(true);
			this.$nextTick(() => {
				this.$refs.ypsdk.ready(
					captchaVerifyParam => this.validCode(captchaVerifyParam)
				).then(
					() => {},
					() => {}
				);
			});
		},

		// 验证码登陆
		loginByPhone() {
			if (this.phoneLock) return;
			if (!this.phoneReg.test(this.phoneNumber)) {
				return (this.errorMsgForm.isPhoneError = true);
			}
			if (this.code === "") {
				return (this.errorMsgForm.isCodeError = true);
			}
			this.phoneLock = true;
			this.$fetch
				.post({
					url: "/login?method=login_by_phone_code",
					params: {
						phone: this.phoneNumber,
						code: this.code,
					},
				})
				.then(
					(data) => {
						if (data.success) {
							if (data.bind_wx) {
								this.openMessage(1, "登录成功");
								this.goToUrl();
							} else {
								// 根据this.$route.query.oa === 'new_ls' 来判断是否是新零售用户
								if (this.$route.query.oa === "new_ls") {
									this.$router.push({
										path: "/sellerRegister",
										query: {
											type: "bind_wx",
											oa: "new_ls",
										},
									});
								} else {
									this.$router.push({
										path: "/sellerRegister",
										query: {
											type: "bind_wx",
										},
									});
								}
							}
						}
					},
					(e) => {
						if (e.error_text.includes("验证码")) {
							this.errorMsgForm.isCodeError = true;
						} else {
							this.openMessage(0, e.error_text || "登录失败");
						}
						this.phoneLock = false;
					}
				);
		},

		// 密码登录
		loginByPwd() {
			if (this.pwdLock) return;
			if (!(this.accountId && this.password)) {
				return this.openMessage(0, "用户名或密码不能为空");
			}
			if (!this.phoneReg.test(this.accountId)) {
				return this.openMessage(0, "请先输入正确的手机号");
			}
			if (!isPasswordEffective(this.password)) {
				this.$refs["passwordTipsDialog"].open();
				return false;
			}
			this.pwdLock = true;
			this.$fetch
				.post({
					url: "/login?method=login_by_phone_password",
					params: {
						phone: this.accountId,
						password: encryption(this.password),
					},
				})
				.then(
					(data) => {
						if (data.success) {
							this.openMessage(1, "登录成功");
							this.goToUrl();
						} else {
							this.openMessage(0, "用户名或密码错误");
						}
					},
					(e) => {
						if (e.error_text.includes("密码错误")) {
							this.openMessage(0, "用户名或密码错误");
						} else {
							this.openMessage(0, e.error_text || "登录失败");
						}
						this.pwdLock = false;
					}
				);
		},

		iptChange(val, prop) {
			let reg = /[^\d]/g;
			if (prop === "password") {
				reg = /[^\d\w]/g;
			}
			this[prop] = val.replace(reg, "");
		},
	},

	components: {
		ypsdk,
		tipsDialog,
	},
};
</script>

<style lang="scss" scoped>
.layout {
	width: 100%;
	height: 100%;
	min-width: 800px;
	padding-top: 130px;
	text-align: center;

	.page-login {
		position: relative;
		display: inline-block;
		width: 720px;
		margin: 0 auto;
		border-radius: 10px;
		background: linear-gradient(
			180deg,
			rgba(255, 90, 18, 0.24) 0%,
			rgba(246, 242, 235, 0.24) 100%
		);

		.logo-img {
			position: absolute;
			bottom: 0;
			left: 0;
			width: 286px;
		}

		.logo-txt {
			display: block;
			margin: 0 auto;
			width: 120px;
			height: 30px;
			line-height: 30px;
			margin-top: 20px;
			font-size: 18px;
			border: 1px #000 solid;
			user-select: none;
			background: transparent;
		}

		.left-img {
			height: 370px;
			width: 290px;
			position: relative;
			overflow: hidden;
		}

		.left-text {
			width: 270px;
			line-height: 1.5;
			padding: 20px 0 0 20px;
			font-size: 28px;
			color: #333;
			letter-spacing: 0;
			text-align: left;

			.senguo-text-logo {
				display: block;
			}
			.login-title {
				margin-top: 10px;
			}
		}

		.right-list {
			position: relative;
			padding: 40px 20px;
			width: 350px;
			border-radius: 0 4px 4px 0;
			position: absolute;
			top: -15px;
			right: 20px;
			border-radius: 10px;
			background-color: #fff;
			box-shadow: 0px 11px 11px 0px rgba(20, 0, 0, 0.09);
			overflow: hidden;

			.half-hide-img {
				position: absolute;
				right: 0;
				top: 0;
				width: 56px;
				height: 56px;
				background: #ff5a12;
				overflow: hidden;
				user-select: none;

				.mask {
					text-align: right;
					padding-top: 5px;
					padding-right: 5px;

					img {
						width: 22px;
						height: 22px;
						cursor: pointer;
					}

					&:after {
						position: absolute;
						left: 0;
						bottom: 0;
						content: "";
						display: block;
						width: 0;
						height: 0;
						border: 48px solid #fff;
						border-top-color: transparent;
						border-left-color: transparent;
						border-bottom-color: transparent;
						transform: rotate(-45deg) translateX(-74px);
						box-shadow: 0 0 5px #ccc;
					}
				}
			}

			.label {
				text-align: center;
				font-size: 24px;
				color: #333;
				font-weight: 600;
			}

			.login-type-tab {
				font-size: 14px;
				text-align: center;
				margin-top: 12px;
				height: 32px;
				line-height: 32px;

				.item {
					display: inline-block;
					width: 88px;
					margin: 0 4px;
					position: relative;
					color: #333;
					border-bottom: 2px solid transparent;
					transition: color 0.2s ease 0s;
					font-size: 14px;
					user-select: none;
					cursor: pointer;
				}

				.active {
					border-bottom: 2px solid #ff5a12;
					color: #ff5a12;
					font-weight: 600;
				}
			}

			.wrap-wx-login,
			.wrap-app-login {
				margin-top: 15px;
				text-align: center;

				.login-qrcode-box {
					position: relative;
					width: 180px;
					height: 180px;
					margin: 0 auto;

					.wrap-login-qrcode {
						position: relative;
						width: 180px;
						height: 180px;
						background-color: #ecf1ef;

						canvas {
							max-width: 100%;
							max-height: 100%;
							min-width: 100%;
							min-height: 100%;
							transition: transform 0.3s ease;
						}

						.app-scan-remind {
							position: absolute;
							right: -45px;
							top: 0;
							width: 90px;
							opacity: 0;
							transition: opacity 0.3s ease;
						}
					}

					.wrap-app-scan-qrcode {
						.app-scan-remind {
							opacity: 1;
						}
						.app-scan-qrcode {
							transform: translate3d(-45px, 0, 0);
						}
					}
					.qrcode-process-remind-translate {
						transform: translate3d(-45px, 0, 0);
					}
				}
			}

			.wrap-qrcode-outtime {
				position: absolute;
				z-index: 5;
				left: 0;
				top: 0;
				width: 100%;
				height: 100%;
				background: rgba(0, 0, 0, 0.6);
				font-size: 14px;
				text-align: center;
				color: #fff;
			}

			.qrcode-process-remind {
				position: absolute;
				left: 0;
				top: 0;
				display: flex;
				flex-direction: column;
				justify-content: center;
				align-items: center;
				width: 100%;
				height: 100%;
				background: rgba(0, 0, 0, 0.6);
				font-size: 14px;
				text-align: center;
				color: #fff;

				.back-to-qrcode {
					margin-top: 20px;
					cursor: pointer;
					font-weight: bold;
				}
			}

			.btn-refresh-qrcode {
				display: inline-block;
				width: 64px;
				height: 34px;
				line-height: 34px;
				margin-top: 10px;
				border-radius: 5px;
				font-size: 16px;
				color: #fff;
				font-weight: bold;
				background: #ff5a12;
			}

			.wrap-usernum-login {
				margin-top: 30px;
			}
		}

		.app-login-info {
			display: flex;
			align-items: center;
			justify-content: center;
			color: #666;
			margin: 30px 0 8px;
			font-size: 12px;

			.app-logo {
				width: 20px;
				height: 20px;
				border-radius: 5px;
				margin: 0 5px;
				filter: drop-shadow(0px 0px 10px rgba(0, 0, 0, 0.3));
			}
		}

		.wx-login-info {
			text-align: center;
			color: #666;
			margin: 30px 0 8px;
			font-size: 12px;
		}

		.wrap-usernum-login {
			margin-top: 30px;

			.login-input {
				height: 50px;
				width: 310px;
				margin-top: 14px;
				position: relative;

				&.ipt-error {
					input,
					/deep/ .el-input__inner {
						border: 1px solid #e51c23;
					}
				}

				input,
				/deep/ .el-input__inner {
					height: 50px;
					width: 310px;
					padding: 0 !important;
					font-size: 14px;
					text-indent: 10px;
					border-radius: 10px;

					&::placeholder {
						color: #333;
					}

					&:focus {
						border: 1px solid #ff5a12;
						box-shadow: 0 0 3px #ff5a12;
					}
				}
			}

			.account-view-header {
				display: flex;
				align-items: center;
				justify-content: space-between;
				margin-bottom: 18px;
				font-size: 13px;
				color: #666;

				span {
					line-height: 1.5;
				}

				a {
					flex: none;
					color: #ff5a12;
					font-weight: 600;
				}
			}

			.get-code {
				position: absolute;
				right: 4px;
				top: 4px;
				background-color: #ff5a12;
				color: #fff;
				text-align: center;
				height: 42px;
				line-height: 42px;
				width: 90px;
				user-select: none;
				cursor: pointer;
				border-radius: 10px;
				font-size: 14px;

				&.get_code {
					background-color: #ddd;
					color: #fff;
					border-color: #ddd;
				}
			}
		}

		.account-extra-links {
			display: flex;
			align-items: center;
			justify-content: center;
			margin-top: 6px;
			font-size: 13px;
			color: #999;

			&.single {
				margin-top: 4px;
			}

			a {
				color: #ff5a12;
			}

			span {
				margin: 0 10px;
				color: #d0d0d0;
			}
		}

		.login-btn {
			width: 310px;
			text-align: center;
			margin: 30px 0 14px 0;
			cursor: pointer;

			button {
				border: none;
				width: 100%;
				height: 50px;
				font-size: 18px;
				line-height: 50px;
				background-color: #ff5a12;
				color: #fff;
				border-radius: 10px;
				box-shadow: 0 4px 10px rgba(0, 0, 0, 0.2);
			}
		}

		.login-privacy {
			text-align: center;
			color: #999;
			font-size: 12px;

			.login-link {
				color: #309cff;
				font-size: 12px;
			}
		}
	}
}

input {
	border: 1px solid #eee;
	outline: 0;
	-webkit-appearance: none;
}

button {
	outline: none;
	cursor: pointer;
}

a {
	text-decoration: none;
}

.fl {
	float: left;
}

.error-msg {
	padding: 8px 10px;
	font-size: 12px;
	color: #e51c23;
	text-align: left;
}
</style>

<style lang="scss">
.app-download-link {
	width: 160px;
	height: 160px;
}
.el-icon-loading {
	font-size: 24px;
	color: #333 !important;
}
</style>
